import { FC, ReactElement } from 'react';
import i18next from 'i18next';
import { ExerciseType } from '../../../../../../shared/utils/enums';
import SecondaryButton from '../../../../components/SecondaryButton';

export type CustomExercise = {
  deDescription: string;
  deName: string;
  enDescription: string;
  enName: string;
  exerciseType: ExerciseType;
}

export const createCustomEnduranceExercise = (): CustomExercise => ({
  enName: i18next.t('exerciseModal.enduranceExercise.enName'),
  enDescription: i18next.t('exerciseModal.enduranceExercise.enDescription'),
  deName: i18next.t('exerciseModal.enduranceExercise.deName'),
  deDescription: i18next.t('exerciseModal.enduranceExercise.deDescription'),
  exerciseType: ExerciseType.ENDURANCE,
});

export const createCustomStaticExercise = (): CustomExercise => ({
  enName: i18next.t('exerciseModal.customExercise.enName'),
  enDescription: i18next.t('exerciseModal.customExercise.enDescription'),
  deName: i18next.t('exerciseModal.customExercise.deName'),
  deDescription: i18next.t('exerciseModal.customExercise.deDescription'),
  exerciseType: ExerciseType.DYNAMIC,
});

type CustomExerciseActionsProps = {
  onCreateCustomExercise: (exercise: CustomExercise) => void;
};

const CustomExerciseActions: FC<CustomExerciseActionsProps> = ({
  onCreateCustomExercise,
}: CustomExerciseActionsProps): ReactElement => {
  return (
    <div className="d-flex flex-wrap gap-2">
      <SecondaryButton type="button" onClick={() => onCreateCustomExercise(createCustomStaticExercise())}>
        <i className="fas fa-plus me-2" />
        {i18next.t('exerciseModal.addStaticExercise')}
      </SecondaryButton>

      <SecondaryButton type="button" onClick={() => onCreateCustomExercise(createCustomEnduranceExercise())}>
        <i className="fas fa-plus me-2" />
        {i18next.t('exerciseModal.addEnduranceExercise')}
      </SecondaryButton>
    </div>
  );
};

export default CustomExerciseActions;
